import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using React Bootstrap for modals

const ViewUnitModal = ({ show, handleClose, unit }) => {
    if (!unit) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Unit Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <div className="mb-3">
                    <strong>Unit Code:</strong> {unit.unitCode}
                </div> */}
                <div className="mb-3">
                    <strong>Type:</strong> {unit.type}
                </div>
                <div className="mb-3">
  <strong>Price:</strong> {Number(unit.price).toLocaleString()} EGP
</div>
                <div className="mb-3">
                    <strong>Area:</strong> {unit.area}
                </div>
                <div className="mb-3">
                    <strong>Location:</strong> {unit.location}
                </div>
                <div className="mb-3">
                    <strong>Number of Bedrooms:</strong> {unit.numberOfBedrooms}
                </div>
                <div className="mb-3">
                    <strong>Number of Bathrooms:</strong> {unit.numberOfBathrooms}
                </div>
                <div className="mb-3">
                    <strong>Finishing:</strong> {unit.finishing}
                </div>
                <div className="mb-3">
                    <strong>Status:</strong> {unit.status === 'approved'
                        ? 'Approved'
                        : unit.status === 'declined'
                            ? 'Declined'
                            : 'Pending'}
                </div>
                <div className="mb-3">
                <strong>Unit Picture: </strong> 
                <a
                                            href={unit.picture}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#487fff', textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            View Document
                                        </a>
                    {/* <img src={unit.picture} alt="Unit" className="mt-2 rounded" style={{ width: '150px', height: 'auto' }} /> */}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewUnitModal;
